export interface BuildInfo {
  gitCommit: string;
  buildTime: string;
}

export interface ServerEnv {
  hostname: string;
  nodeEnv: string;
  httpPort: string;
  channelPort: string;
  channelMode: string;
}

export function getBuildInfo(): BuildInfo {
  return __BUILD_INFO__;
}

export function getServerEnv(): ServerEnv | null {
  return window.__serverEnv ?? null;
}

export function isDev(): boolean {
  return getServerEnv()?.nodeEnv === 'development';
}
